import { MeasurementType } from "./measurement-type";
import { Asset } from "./asset";

export class AssetMeasurement {
  description: string;
  alias: string;
  name: string;
  sampleRate: number;
  dateLastValueReported: number;
  lastValueReported: string;
  measurementType: MeasurementType;
  asset: Asset;
  uuid: string;
}
